import styled from "styled-components";

import { colorsPalettes, setFont } from "@similarweb/styles";
import { ShareBarChart } from "@similarweb/ui-components";

import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SegmentsValidationContainer = styled(FlexColumn)`
    height: 110px;
    width: 312px;
    background-color: ${colorsPalettes.carbon["25"]};
    padding: 24px 24px 18px 24px;

    @media screen and (max-width: 1280px) {
        width: 100%;
    }
`;

export const DataWrapper = styled(FlexRow)`
    width: 225px;
    margin-top: 16px;
    justify-content: space-between;
`;

export const TitleRow = styled(FlexRow)`
    ${setFont({ $size: 14, $weight: 400, $color: colorsPalettes.carbon[300] })};
`;

export const DataRow = styled(FlexRow)<{ isLow?: boolean }>`
    margin-top: 10px;
    ${({ isLow }) =>
        setFont({
            $size: 20,
            $weight: 700,
            $family: "DM Sans",
            $color: isLow ? colorsPalettes.red["s100"] : colorsPalettes.carbon[400],
        })};
`;

export const StyledShareBar = styled.div`
    width: 80px;
    margin-top: 6px;
    ${ShareBarChart} {
        height: 4px;
    }
`;
